export class Schedule {
  public name: string;
  public buss: string;
  public start: Date;
  public end: Date;
  public comment: string;
  public userMappingId: string;
  public skill: string;
  public checkedin: boolean;
  public lateToWork: boolean;
  public id: string;
  public activityName: string;
  public airportId: string;

  public get skillString() {
    let skills = JSON.parse(this.skill) as string[];
    return skills[0];
  }

  public static ToTypeSafe(schedule: Schedule) : Schedule {
    let typeSafeSchedule = new Schedule();
    typeSafeSchedule.name = schedule.name;
    typeSafeSchedule.buss = schedule.buss;
    typeSafeSchedule.start = new Date(schedule.start);
    typeSafeSchedule.end = new Date(schedule.end);
    typeSafeSchedule.comment = schedule.comment;
    typeSafeSchedule.userMappingId = schedule.userMappingId;
    typeSafeSchedule.skill = schedule.skill;
    typeSafeSchedule.checkedin = schedule.checkedin;
    typeSafeSchedule.lateToWork = schedule.lateToWork;
    typeSafeSchedule.id = schedule.id;
    typeSafeSchedule.activityName = schedule.activityName;
    typeSafeSchedule.airportId = schedule.airportId;

    return typeSafeSchedule;
  }

  public static ToTypeSafeList(schedules: Schedule[]): Schedule[] {

    return schedules.map((s) => { return Schedule.ToTypeSafe(s); });

  }
}

export class ScheduleListUpdates {
  public successfulUpdates: Schedule[] = [];
  public failedUpdates: FailedScheduleUpdate[] = [];
}

export class FailedScheduleUpdate {
  public schedule: Schedule;
  public errorMessage: string;
}
